import MediaCommand from './MediaCommand';
import RecordCommand from './RecordCommand';

class StudentApp {
    constructor(
        streamManager,
        recorder
    ) {
        this.streamManager = streamManager;
        this.recorder = recorder;

        this.mediaCommandRecord = new MediaCommand(
            this,
            this.streamManager,
            new RecordCommand(this.recorder)
        );
    }

    getMediaCommandForRecording() {
        return this.mediaCommandRecord;
    }

    getRecorder() {
        return this.recorder;
    }

    getStreamManager() {
        return this.streamManager;
    }
}

export default StudentApp;
